var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfiniteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "105px",
    height: "50px",
    viewBox: "0 0 105.0 50.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.50296,0 C95.44706,0 104.82606,9.708 104.82606,24.5996 C104.82606,39.4912 95.44706,49.1992 81.50296,49.1992 C74.24806,49.1992 68.00096,46.1728 61.48636,39.876 L52.41306,31.0693 L43.33986,39.876 C36.82516,46.1728 30.57816,49.1992 23.32326,49.1992 C9.37886,49.1992 0,39.4912 0,24.5996 C0,9.708 9.37886,0 23.32326,0 C30.57816,0 36.82516,3.0264 43.33986,9.3232 L52.41306,18.1299 L61.48636,9.3232 C68.00096,3.0264 74.24806,0 81.50296,0 Z M23.32326,9.4971 C15.05176,9.4971 9.49706,15.3496 9.49706,24.5996 C9.49706,33.8496 15.05176,39.7021 23.32326,39.7021 C27.90136,39.7021 32.03026,37.5176 36.70116,33.1133 L45.73926,24.5996 L36.70116,16.0859 C32.03026,11.6816 27.90136,9.4971 23.32326,9.4971 Z M81.50296,9.4971 C76.92476,9.4971 72.79586,11.6816 68.12496,16.0859 L59.08696,24.5996 L68.12496,33.1133 C72.79586,37.5176 76.92476,39.7021 81.50296,39.7021 C89.77446,39.7021 95.32906,33.8496 95.32906,24.5996 C95.32906,15.3496 89.77446,9.4971 81.50296,9.4971 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1207.2552 -4.257800000000088)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1207.40114 4.404300000000148)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 104.82606,0 104.82606,49.1992 0,49.1992 0,0",
    stroke: "none",
    fill: "#34C758"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfiniteIcon);
export default __webpack_public_path__ + "static/media/infinite-icon.f9cd10b616f3e3c9f3b1e98e2c2bddbf.svg";
export { ForwardRef as ReactComponent };